import { render, staticRenderFns } from "./NavigationWithDots.vue?vue&type=template&id=23dc01f2&scoped=true&"
import script from "./NavigationWithDots.vue?vue&type=script&lang=js&"
export * from "./NavigationWithDots.vue?vue&type=script&lang=js&"
import style0 from "./NavigationWithDots.vue?vue&type=style&index=0&id=23dc01f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dc01f2",
  null
  
)

export default component.exports